import { Component, OnInit } from '@angular/core';import { WebapiService } from '../webapi.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-chatconfig',
  templateUrl: './chatconfig.component.html',
  styleUrls: ['./chatconfig.component.scss'],
})

export class ChatconfigComponent implements OnInit {

 defaultTech = `You must respond with ONLY valid Python code. Your response MUST:
    - Begin exactly with: \`\`\`python
    - End exactly with: \`\`\`
    - Contain no text before or after the code block.
    - Contain no explanations, reasoning, or markdown outside the code block.

    Task Rules:
    1. The user has uploaded multiple CSV files. Read the user's question and identify which CSV files are needed.
    2. Generate Python code using pandas to answer the user's question.
    3. The generated code MUST:
    - Load files only with generate_file_pd(filename). Never use pd.read_csv.
    - Stricktly do not define generate_file_pd(filename) funtion
    - Stricktly do not define any subfunction. write code in single source
    - Produce a result stored in variable final_df.
    - If result can be represented as a dataframe, final_df must contain that dataframe and result_type must be "dataframe",
       and  don't  write a csv file at end by using final_df.final_df should be dataframe.
    - If it cannot be a dataframe, store a JSON string in variable final_df and set result_type to "json".
    - In python code should write natural_response variable where result  should be in html format instruction to generate:
        1) a result should in  natural-language that is the summary or highlighted content of result (max 300 words) 
        2) Should be in well html formated applying  inline css 
        3) can use icon html font where can be used
        4) use list or table where we can use.
        5) output should be well readable for user
        6) natural_response should not be a plan textual or tabular version of final_df. it should bue summary text in html format
        7) dont exceed word count  limit that is 200 for natural_response. 
    4. Do NOT draw graphs or use any visualization libraries.
    5. Only import: pandas, numpy, json, datetime, re, math, collections, itertools, statistics.
    6. JSON timestamps must be converted from ISO 8601 (e.g., 2025-08-25T11:30:00) to a human-readable format (e.g., Aug 25, 2025).
    7. Unknown or non-serializable objects should be converted to strings or ignored.
    8. Never use include_groups in groupby.apply.
    9. For top-N per group, use:
        df.sort_values(...).groupby(...).head(n)
    Not nlargest.
    10. Never use seaborn, scikit-learn, plotly, statsmodels, matplotlib, or any third-party libraries.
    11. Never use google:search or external web info.
    12. Treat all column names strictly as dataset values with no external interpretation.

    Your answer MUST be Python code only, inside the required code block, with no extra output.`;
  congif = {
    iId:"-1",
    sName:"",
    sjsonconfig:"",
    sotherprompt:"",
    stechprompt:this.defaultTech,
    _by:"",
    sdescription:"",
    smodule:"",
    shintquestion:'[]',
    plugins:'{}'
  }
  page=0;
    dropdownSettings:IDropdownSettings;

  constructor(private service:WebapiService) { 

    this.getall_files();
    this.getall_botlist();
    this.getall();
  }
selectedItems:any=[]
  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'type',
      textField: 'type',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      itemsShowLimit:1

    };

  }
remove(i){
this.selectedItems.splice(i,1);
}
  getlist(){
    var list:any=[]
    this.selectedItems.forEach(element => {
      list.push(element.type);

    });
    return list;

  }
  
  reset(){
    this.congif = {
    iId:"-1",
    sName:"",
    sjsonconfig:"",
    sotherprompt:"",
    stechprompt:this.defaultTech,
    _by:"",
    sdescription:"",
    smodule:"",
    shintquestion:'[]',
    plugins:'{}'
    
  }
  
  this.selectedItems=[]
  this.files=[]
  this.updateflag=false;
  }
setdefault(){
    this.congif.stechprompt=this.defaultTech;
  }

   downloadCSVFromJSON(dataArray, filename = 'data.csv') {
    if (!dataArray || !dataArray.length) {
        console.error('Empty or invalid data array provided');
        return;
    }

    const csvRows = [];

    // Get headers
    const headers = Object.keys(dataArray[0]);
    csvRows.push(headers.join(','));

    // Loop through rows
    for (const row of dataArray) {
        const values = headers.map(header => {
            let val = row[header] !== null && row[header] !== undefined ? row[header] : '';
            val = val.toString().replace(/"/g, '""'); // escape quotes
            if (val.search(/("|,|\n)/g) >= 0) {
                val = `"${val}"`; // wrap in quotes if needed
            }
            return val;
        });
        csvRows.push(values.join(','));
    }

    // Create Blob
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create download link and click
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
listpage=0;
setpagelist(i){
this.listpage=i;
}
files:any;
stype=""
stype_new=""
 upload(e)
  {

    this.files=e.target.files;
    console.log(this.files);
      // this.uploadstatus=true;
      // this.uploadstatus_message="Please wait.."

      // var form_data = new FormData();  
      //       //console.log(model);
      //       console.log(e.target.files)
      //       for(var i=0;i<e.target.files.length;i++)
      //           form_data.append('file', e.target.files.item(i)); 
            
      //           form_data.append('type', this.stype); 
      //           form_data.append('uby', localStorage.getItem("email")); 

      //           this.service.postData1(form_data, 'upload').then((result) => {
      //             var temp: any = result;
      //             this.resultr = temp
      //             console.log("2");
      //             this.uploadstatus=true;
      //             this.uploadstatus_message="File uploaded successfully"

      //             this.getall();
                  
            
      //       }).catch(e => {
      //         this.uploadstatus=true;
      //         this.uploadstatus_message="Somthing goes wrong!";
                 
      //       });
    
           
  }
onCodeInput(event: Event) {
  const target = event.target as HTMLDivElement;
  this.selected_code = target.innerText;   // update model safely
}
  updateflag=false;
  uploadstatus=false;
  uploadstatus_message="";
  selected_code=""
    selected_key=""

  showcodeflag=false;
  set_selected_code(code,key){
     this.selected_code=code;
     this.selected_key=key;
     this.showcodeflag=true;
  }
  close(){
         this.showcodeflag=false;

  }
  async check_file_type(type: string): Promise<any> {
  try {
    const result = await this.service.postData1({ type: type }, 'check_file_type');
    console.log(result);
    return result;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}
  function_sources:any={}

  async upload_file_type(e)
  {
    

      this.uploadstatus=true;
      this.uploadstatus_message="Please wait.."

      var form_data = new FormData();  
            //console.log(model);
            console.log(e.target.files)
            for(var i=0;i<e.target.files.length;i++)
                form_data.append('file', e.target.files.item(i)); 
              if(this.stype!='new')
                form_data.append('type', this.stype); 
              else
              {
              
                  const res = await this.check_file_type( this.stype_new);
                  if(res && res.result === 0)
                    form_data.append('type', this.stype_new);
                  else
                    {
                       this.uploadstatus=true;
                       this.uploadstatus_message="This file name is all ready exits.you can update it from MLE Training / here if it is listed"
                       return;

                    } 
              
              }
              
                form_data.append('other1', "chatbotfiles"); 
                form_data.append('other2', ""); 

                form_data.append('uby', localStorage.getItem("email")); 

                this.service.postData1(form_data, 'upload_file_type').then((result) => {
                  var temp: any = result;
                  console.log("2");
                  this.uploadstatus=false;
                  this.uploadstatus_message="File uploaded successfully"

                  this.getall();
                  this.getall_files();
            
            }).catch(e => {
              this.uploadstatus=false;
              this.uploadstatus_message="Somthing goes wrong!";
                 
            });
    
           
  }

  async  handleFileUpload(e: Event) {
  const input = e.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];

  console.log("Uploaded file:", file.name);

  this.function_sources = await this.pyFileObjectToFunctionResource(file);

  console.log("Converted function_sources:", this.function_sources);
    input.value = '';

}

getfunctionlist(obj)
{
 var list = Object.entries(obj).map(([key, value]) => ({
  key,
  value
}));
  return list;
}

  async pyFileObjectToFunctionResource(
  file: File
): Promise<Record<string, string>> {

  const text = await file.text();
  const lines = text.split(/\r?\n/);

  const functions: Record<string, string> = {};

  let inside = false;
  let currentName = "";
  let buffer: string[] = [];
  let baseIndent = 0;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    // ✅ Match function definition
    const match = line.match(/^(\s*)def\s+([a-zA-Z_]\w*)\s*\(/);

    if (match) {
      // ✅ Save previous function
      if (inside && currentName) {
        functions[currentName] = buffer.join("\n").replace(/\s+$/, "");
        buffer = [];
      }

      inside = true;
      currentName = match[2];
      baseIndent = match[1].length;
      buffer.push(line);
      continue;
    }

    // ✅ Capture all indented lines under the function
    if (inside) {
      const indent = line.match(/^\s*/)?.[0].length || 0;

      if (
        line.trim() === "" ||           // blank lines allowed
        indent > baseIndent             // still inside function
      ) {
        buffer.push(line);
      } else {
        // ✅ Function ended
        functions[currentName] = buffer.join("\n").replace(/\s+$/, "");
        buffer = [];
        inside = false;
        currentName = "";
      }
    }
  }

  // ✅ Save last function if file ended
  if (inside && currentName) {
    functions[currentName] = buffer.join("\n").replace(/\s+$/, "");
  }

  if (!Object.keys(functions).length) {
    throw new Error("No valid Python functions found in uploaded file");
  }

  return functions;
}
   configfilelist:any=[]

   delete_file(type){
    if (confirm('Are you sure you want to delete this file?')) {
            this.service.postData({type:type}, 'delete_file_type').then((result) => {

               this.getall();
             });
  } else {
    console.log('Cancelled.');
  }
             
   }

   D_flag:any=true
   D_i=-1;
   download(type,i) {

  this.D_i=i
//   this.service.postData({}, 'download/'+type).then((result) => {
//     var temp: any = result;
//     this.resultr = temp
//     console.log(this.resultr);

// })

this.D_flag=true;
this.service.download(type).then((result) => {
  this.D_flag=false;
  this.D_i=-1

});
}

  getall()
  {
    this.filelist=[]
         this.service.postData({type:'chatbotfiles'}, 'getallfiletype').then((result) => {
                  var temp: any = result;
                   console.log(temp)
                  
                  
                  this.configfilelist =temp.data
      
            
            }).catch(e => {
            
            });
            
            
  }

  hintypelist:any=[]
  addHinttypeflage=false;
  newHintTypetext:string=''
  
  addHinttype(){

    if(!this.addHinttypeflage)
    {
      this.addHinttypeflage=true;

    }else{

      this.hintypelist.push(this.newHintTypetext);
      this.addHinttypeflage=false;
      this.newHintType=this.newHintTypetext;
    }
  }
  updatehintflag=false;
  selectedhint=0;
  setupdate(i){
    if(this.hintList[i].type)
     this.newHintType=this.hintList[i].type;
    else
      this.newHintType=''

      setTimeout(() => this.autoGrowFromModel());

    this.newHint=this.hintList[i].question;
    this.updatehintflag=true;
    this.selectedhint=i;

  }
  updatehint(){
     if (this.newHint.trim() !== '') {
      this.hintList[this.selectedhint]={ question: this.newHint.trim(),type:this.newHintType };
      this.newHint = '';
      this.updatehintflag=this.files;

    }
  }
  select(x)
  { 


    this.congif = x
    this.selectedItems=[]
    console.log(this.congif)
    const fixedJSON = JSON.parse(this.congif.sjsonconfig).replace(/\bNaN\b/g, 'null');
    JSON.parse(fixedJSON).forEach(element => {
      this.selectedItems.push({type:element.file_name.split(".")[0]});
    });

    this.hintList=JSON.parse(this.congif.shintquestion)
    this.hintypelist=this.getDistinctTypes(this.hintList);
    this.updateflag=true;
     this.addHinttypeflage=false;
     if(this.congif.plugins!=null && this.congif.plugins!='null' &&this.congif.plugins!='{}' )
       this.function_sources = JSON.parse(this.congif.plugins)
      else
        this.function_sources ={}

     
  }
  saveloader = false;
  save_config(){

    this.saveloader = true;

    var form_data = new FormData();  
            //console.log(model);
            console.log(this.files)
            if(this.files)
            {
                for(var i=0;i<this.files.length;i++)
                    form_data.append('sfile',this.files.item(i)); 
                }
                // form_data.append('type', this.stype); 
                form_data.append('iId', this.congif.iId); 

                form_data.append('uby', localStorage.getItem("email")); 
                form_data.append('sName', this.congif.sName); 
                form_data.append('sotherprompt', this.congif.sotherprompt); 
                form_data.append('stechprompt', this.congif.stechprompt); 
                form_data.append('sdescription', this.congif.sdescription); 
                form_data.append('smodule', this.congif.smodule); 
                form_data.append('shintquestion', this.getJson()); 
                form_data.append('plugins', JSON.stringify(this.function_sources)); 


                
                this.service.postData1(form_data, 'add_bot_config').then((result) => {
                  var temp: any = result;
                  // this.resultr = temp
                   console.log("2");
                  // this.uploadstatus=true;
                  // this.uploadstatus_message="File uploaded successfully"

                  // this.getall();
                  
                  this.saveloader=false;
                  this.getall_botlist();

            
            }).catch(e => {
              // this.uploadstatus=true;
              // this.uploadstatus_message="Somthing goes wrong!";
                 
            });

    
  }
  export(x) {
    console.log(x);

    // Convert JSON object to string
    const jsonString = JSON.stringify(x, null, 2);

    // Create a Blob
    const blob = new Blob([jsonString], { type: "application/json" });

    // Create a temporary download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);

    // File name from x.sName
    link.download = `${x.sName}.json`;

    // Trigger download
    link.click();

    // Cleanup
    URL.revokeObjectURL(link.href);
  }

  importingflag=false;

  onFileUpload(event: any) {
    
    this.importingflag=true;
    const file: File = event.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const jsonObject = JSON.parse(e.target.result);

        console.log("Uploaded JSON Object:", jsonObject);

            this.service.postData(jsonObject, 'import_bot_config').then((result) => {
                var temp: any = result;
                console.log(result)
                alert("Imported successfully")
                event.target.value=""
                this.getall_botlist();

                this.importingflag=false;
            });


        // ✅ Use your JSON object here
        // this.processJson(jsonObject);

      } catch (error) {
        alert("Invalid JSON file");
      }
    };

    reader.readAsText(file);
  }
  templaeloader=false;
  generate_Template(){

    this.templaeloader=true;
    this.service.postData1({"csv_files":this.getlist()},'get_template').then(res=>{
      var result:any=res;
      console.log(res);

      this.downloadCSVFromJSON(JSON.parse(result.df_json),"config.csv");

        this.templaeloader=false;

    });
  }
   setpage(k){
    this.page=k;
  }

  autoGrowFromModel() {
    const textarea = document.getElementById('myTA') as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }
  autoGrow(event: any) {
  const textarea = event.target;
  textarea.style.height = 'auto';      // reset height
  textarea.style.height = textarea.scrollHeight + 'px'; // set to content height
}
  chat_config_Delete(x){
            if (confirm('Are you sure you want to delete this botconfig?')) {

      this.service.postData({iId:x.iId}, 'chat_config_Delete').then((result) => {
                  var temp: any = result;
                   console.log(temp)
                  
                  this.getall_botlist();                

                
            
            }).catch(e => {
             

            });
          }
            
  }
  chat_deactivate(x,i){
        if (confirm('Are you sure you want to deactivate this botconfig?')) {

     this.service.postData({iId:x.iId,value:i}, 'deactivate_config_Delete').then((result) => {
                  var temp: any = result;
                   console.log(temp)
                  
                  this.getall_botlist();                

                
            
            }).catch(e => {
             

            });
          }
           
  }
  filelist:any=[]
   getall_files()
  {
    
    this.filelist=[]
         this.service.postData({type:'c'}, 'getallfiles_system').then((result) => {
                  var temp: any = result;
                   console.log(temp)
                  
                 
                  this.filelist =temp.data
                

                
            
            }).catch(e => {
             

            });
            
            
  }
  config_list:any=[]
  botloader=false;
   getall_botlist()
  {
    
    this.botloader=true;

    this.config_list=[]
         this.service.postData({type:'c'}, 'getall_bot_config').then((result) => {
                  var temp: any = result;
                   console.log(temp)
                  
                 
                  this.config_list =temp.data

    this.botloader=false;

                

                
            
            }).catch(e => {
             

            });
            
            
  }
  delete(x)
  {

  }
  deactivate(x)
  {

  }

  // hint
  hintList: any[] = [];
  newHint: string = '';
  newHintType:string=''
  // Add a hint question
  addHint() {
    if (this.newHint.trim() !== '') {
      this.hintList.push({ question: this.newHint.trim(),type:this.newHintType });
      this.newHint = '';
    }
  }

  // Remove a hint
  removeHint(index: number) {
    this.hintList.splice(index, 1);
  }

  // Returns final JSON string
  getJson() {
    return JSON.stringify(this.hintList, null, 2);
  }

    getDistinctTypes(hintList: { question: string; type: string }[]): string[] {
      return [...new Set(hintList.map(h => h.type))];
    }
  // Check if JSON is valid
  isValidJSON(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  }

  
}
